const messages = {
  successMessage: "Realizado con éxito",
  notFound: "No se encontró el registro",
  preguntaEliminar: "¿Estas seguro de querer eliminar este registro?",
  errorMessage: "Lo sentimos hemos experimentado un error",
  accessMessage: "No tiene permisos para realiza esta accion",
  evaluationNotAvailable: "La evaluacion ya no esta disponible",
  descriptorErrorMessage: "Este colaborador no tiene su descriptor completo",
  networkError:
    "Hemos experimentado un error de red, verifica tu conexión a internet",
  applicationError:
    "Lo sentimos hemos experimentado un error de aplicación, por favor contacte al administrador del sistema",
  serverNotResponse: "El servidor no responde, por favor intenta mas tarde o contacta al administrador del sistema",
  serverError : "Error en el servidor por favor contacte al administrador del sistema",
  requestConfigError: "Error en la configuración de la solicitud",
  correoEnviado: "Correo enviado con éxito",
  cancelRequest: "¿Estas seguro de querer cerrar esta solicitud?",
  copyRequest: "¿Estas seguro de querer copiar este registro?",
  validYear: "Ingrese un año valido",
  dateChanged: "Fecha modificada con exito",
  fileError: "Ocurrio un error al generar el documento",
  fileSuccessMessage: "Archivo cargado con exito",
  campaniaSend: "Campaña enviada con éxito",
  factorSelect: "Debe marcar todos los factores de criticidad",
  recordAlreadyExists: "El registro ya existe",
};

export default messages;
